// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2U5ro","error":"Textarea_error__13OVv","readonly":"Textarea_readonly__2jUmX","disabled":"Textarea_disabled__38JtC"};